// extracted by mini-css-extract-plugin
export default {"root":"Mh9rU","container":"MmE7P","avatar":"Mp9JZ","name":"pQ1BC","button":"gz84w","myMessage":"FEqrZ"};